import { Dispatch } from "redux";
import request from "../../Requests/requests";
import { getSpentTime } from "../SpentTimeTask/getSpentTime";

export function addRunTime(payload: { id: any; seconds: any }) {
  localStorage.removeItem('time');
  return async (dispatch: Dispatch) => {
    try {
      const response = await request.post('/Time/RunTime/?TaskId=' + payload.id + '&UserId=' + localStorage.getItem('userID') + '&Time=' + payload.seconds)
      const data = response.data
      dispatch<any>(getSpentTime())
      return data
    } catch (error) {
      return error
    }
  };
}